import React from "react";
import styles from "./Team.module.scss";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const Team = () => {
  return (
    <div className={styles.background}>
      <div className={styles.title}>
        <h1 className={styles.bg}>OUR TEAM</h1>
        <h1 className={styles.fg}>OUR TEAM</h1>
      </div>
      <div className={styles.outercontainer}>

      <h1 className={styles.coreteam}>Core Team</h1>
      <div className={styles.container1}>
      <div className={styles.box1}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vRCN1HGxUxSb7u6VNZGFkbd7fNPgx22dl12KVCBZrQIe_HevxcxpvFKpGs0L3E-2jJCh43k_Pb17pCJ/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Aninda Saha</h4>
          <p className={styles.position}>GDG Organizer</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/aninda-saha-160230196/" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        <div className={styles.box1}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vSaCtYGLCmkHln_ED0KIOVva7ugx26sGaq9UqGdLvDnygkEQGLz43GjqKch3cwUHuO3M4AYqsn-5FUE/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Souvik Karmakar</h4>
          <p className={styles.position}>GDG Organizer</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/souvik-karmakar-9727bb204/" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        <div className={styles.box1}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vQe92fjPwWTetXQQzlcJS0IxYsRAD09LpctYErVj8W9Deo2N-1g55Fpf0d4TT0OGx_Dxg3vq5DXEFWl/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Priyanka Singh</h4>
          <p className={styles.position}>GDG Organizer</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/priyanka-singh-cse" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        <div className={styles.box1}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vSYg5I5-ND8u2Atwquy-0NIgDyULx950WMbil6UtBKclwWEwz--17XFHHxks_rRMSYCXZ9drwkHTXBE/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Arka Saha</h4>
          <p className={styles.position}>PR</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/arka-saha-589843204" target="_blank"><LinkedInIcon className={styles.icon} /></a>
          </div>
        </div>
        
        <div className={styles.box1}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vSBD-FHaVkZPOr7ZFs8F1Tc6Tj_RuceyF-t_3CPoOhE3AEtDz25ONC8w7WEZIom_aNb6l0lZtcj6QWi/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Tanushri Das</h4>
          <p className={styles.position}>Content Creation</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/tanusri-das-82213321a" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        
        <div className={styles.box1}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vQaH8cWr0X-zOcFyNt5c6EEkbTT9QIwKJVpuHggrCZdJwpPHnlTUzxKGVaBSw_x-m0YliSZ8i50qYuw/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Debjyoti Mukherjee</h4>
          <p className={styles.position}>Social Media</p>
          
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/mrdevmukherjee/" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        
       
      </div>
      </div>
      {/* container1 ends */}
      <div className={styles.outercontainer}>
      <h1 className={styles.coreteam}>Volunteers</h1>
      <div className={styles.container}>
       
        <div className={styles.box}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vSHg2NvB4xAP1EPOGZPLOBrHZnq_c5s9qku3IKS5GlUsBaTR1gWPWkMZbR96DNnbyQwlYkb1BT3QuDF/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Subhajit Gorai</h4>
          <p className={styles.position}>Website Team</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/subhajit-gorai/" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        <div className={styles.box}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vS0z3NChvy-AY0LpoSaUT66wKjKF1K-VTIcqVXMW7EUJhg3yzSRo68MvfKlYgnDgAlb3gzFFyTFZ3ix/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Abhishek Dasgupta</h4>
          <p className={styles.position}>Website Team</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/abhishek-dasgupta-819211147/" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        <div className={styles.box}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vQod9JkhJ7cjqOIeoVmTtiSqgUXtNSY6apfALq2bYieuUU96pXOouLETAdq3qyLDcDANrRQSdQ_Qbbh/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Pritam Panda</h4>
          <p className={styles.position}>Website Team</p>
          <div className={styles.socials}>
          <a href="https://linkedin.com/in/pritam-panda-3553961bb" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        <div className={styles.box}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vQLHNda07RQgeTMsjKjxYhxOTXtw-dXCvW-X_u4A3wLtu48K2aVYru-KV2S_NS6U_EVLA_6nWxolIsx/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Oishi Sen</h4>
          <p className={styles.position}>Graphics Team</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/oishi-sen-29538222a/" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        <div className={styles.box}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vRSWa4mLtNSnS3JdWYemtT18F5KiJXFX3W-59neyk080FsL6VpMEMmf8XZgCtc2FbM6bHts4ykv44YE/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Subhasree Maji</h4>
          <p className={styles.position}>Outreach</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/subhasree-maji-1a084123a/" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        
        
        
        <div className={styles.box}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vQnCFq3VDOtCIM1co6qQmzkcv4Lk2A_yo7438NF5eE4csmrSIUnnic_E-WNbjhBuMMxaR40nHtoYz-J/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Soaham Guha</h4>
          <p className={styles.position}>Outreach</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/soaham-guha-11b830225" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        
        <div className={styles.box}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vSkkHsisTZqVlR6Wcl26tVFZ9YS14q_s3RKo9ECrXq_cbJzypbAcylHSC1DFtOiEMEGlemQZyr3SW8-/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Ankita Bandyopadhyay</h4>
          <p className={styles.position}>Outreach</p>
          <div className={styles.socials}>
            <a href="https://www.linkedin.com/in/ankita-bandyopadhyay-1a72b922a"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        <div className={styles.box}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vTarDCGSGDI5XkCy69iX4306Nh-BfAxva6AcOd70Q8F643QDZyoPRilLrmXoVj_UjEhNaXGedrsqojl/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Arpanendu Khag</h4>
          <p className={styles.position}>Graphics Team</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/arpanendu-khag-a64408203" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        
        
        <div className={styles.box}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vTLY6kROf6Rj9i3oVa-rBuQYrCCft1g0P3jzVRqhseogaTDz69WpAGKCMeplYrRuTDqbP1I7fv_Un-0/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Aniket Shaw</h4>
          <p className={styles.position}>Outreach</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/aniket-shaw-6b4240247" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        <div className={styles.box}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vTJOE80G8BxTQoiiS12PupCi7LmDB4szV611T5sdeQXWw1hGGnNwwa99I9sjQzCxvTKASSwK9Yt8qX9/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Sunetra Roy</h4>
          <p className={styles.position}>Outreach</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/sunetra-roy-179788251" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
       

        <div className={styles.box}>
          <img
            src="https://docs.google.com/drawings/d/e/2PACX-1vQx6rrmWDCn1q5SpS4WqK5fSdyqOgpelelLEfKrXmc0_cq84HeqUQ80QyWJpKOSeto4SsrEu9B2Et7l/pub?w=440&amp;h=440"
            className={styles.img}
            alt=""
          />
          <h4 className={styles.name}>Soumojyoti Konar</h4>
          <p className={styles.position}>Outreach</p>
          <div className={styles.socials}>
          <a href="https://www.linkedin.com/in/" target="_blank"><LinkedInIcon className={styles.icon} /></a>
           
          </div>
        </div>
        
       
      </div>
      </div>
      </div>

          
  );
};

export default Team;
